<div class="reward-card-skeleton" aria-hidden="true">
  <div class="skeleton-content">
    <div class="skeleton-title"></div>
    <div class="skeleton-title skeleton-title-short"></div>
    <div class="skeleton-progress">
      <div class="skeleton-progress-track"></div>
      <div class="skeleton-progress-text"></div>
    </div>
    <div class="skeleton-badge"></div>
  </div>
  <div class="skeleton-image"></div>
</div>
